var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.192 5.02245L4.864 0.197604C5.136 -0.0658684 5.552 -0.0658684 5.808 0.197604C6.064 0.461078 6.064 0.905688 5.808 1.16916L1.6 5.5L5.808 9.83084C6.064 10.1108 6.064 10.5389 5.808 10.8024C5.552 11.0659 5.136 11.0659 4.864 10.8024L0.192 5.99401C-0.0639999 5.71407 -0.0639999 5.28593 0.192 5.02245Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.01132054d7ea6b9b1b36c644678098f8.svg";
export { ForwardRef as ReactComponent };